<app-dialog [dialogWithInput]="dialog">
    <app-card label="Erreur" *ngIf="actionService.error$ | async as error">
        <app-error-text [error]="error"></app-error-text>
    </app-card>
    <app-card class="text-center">
        <app-loading *ngIf="interval > 0" text="Veuillez payer sur le lecteur de carte"></app-loading>

        <ng-container *ngIf="result">
            <div class="d-block">
                <ng-container *ngIf="result.summary.status.value === PaymentRequestOnlineAttemptStatus.PAYMENT_ONLINE_STATUS_SUCCESSFUL">
                    <i-tabler name="check" class="icon-42" ></i-tabler>
                    Paiement reçu
                </ng-container>
                <ng-container *ngIf="result.summary.status.value === PaymentRequestOnlineAttemptStatus.PAYMENT_ONLINE_STATUS_CANCELLED || result.summary.status.value === PaymentRequestOnlineAttemptStatus.PAYMENT_ONLINE_STATUS_FAILED">
                    <i-tabler name="x" class="icon-42" ></i-tabler>
                    Paiement non reçu
                </ng-container>
            </div>
        </ng-container>
    </app-card>
    <app-card title="Détails" *ngIf="result">
        <div class="row">
            <app-form-field label="Montant" size="12">
                <app-price-label [price]="result.summary.amount"></app-price-label>
            </app-form-field>
            <app-form-field label="Statut" [size]="12">
                {{result.summary.status.label}}
            </app-form-field>
        </div>
    </app-card>
</app-dialog>
